
import { defineComponent,PropType,ref,Ref,provide,watchEffect,onMounted,computed } from 'vue';
import ListUpload from "@/components/ListUpload.component.vue";
import {UpFile} from "@/models/objFiles.interface";
import {UserService} from "@/services/user.service";
import {FilesService} from "@/services/files.service";

export default defineComponent({
 components:{
    ListUpload
 },
 setup(){
      let loaded_files:Ref<File[]> = ref([]);
      const userService = new UserService();
      const fileService = new FilesService();
      let objSubm:Ref<UpFile> = ref({enterprise:" ",files:[]});
      let mostrarGif:Ref<Boolean> = ref(false);
      let mostrarAlerta:Ref<Boolean> = ref(false);
      

      provide("loaded_files",loaded_files);

      watchEffect(()=>loaded_files.value.length);

      

      
      const upFiles =async()=>{
	  if (objSubm.value.enterprise !== " " && loaded_files.value.length>0){
	    mostrarGif.value=true; 
	    const formData = new FormData();
	    objSubm.value.files=loaded_files.value;
	    try{
	    formData.append("enterprise",objSubm.value.enterprise);

	    loaded_files.value.forEach(file=>{formData.append("files",file)});
	    	    
	    const resultado = await fileService.uploadFiles(userService.fetch().token,formData);
	     if(resultado){
		mostrarAlerta.value=true;
		mostrarGif.value=false; 
		window.location.reload();
	     }

	    }catch(err){
	     console.log(err);
	    }

	  }
      };

  return {loaded_files,objSubm,upFiles,mostrarGif,mostrarAlerta};
 }
});
